import { Link } from "react-router-dom";
import { allBlogArticles } from "@/mocks/blogContent";

export default function BlogMatrix() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 mb-3">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          Latest SEO Articles
        </div>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          Mulebuy Spreadsheet Insights
        </h2>
      </div>

      {/* Blog Grid - 11 article cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {/* Card 1 - Text with large author */}
        <Link
          to={`/blog/${allBlogArticles[0].slug}`}
          className="bg-white rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer flex flex-col gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center overflow-hidden">
              <span className="text-accent-700 font-semibold text-sm">
                {allBlogArticles[0].author.split(" ").map((n) => n[0]).join("")}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-900">{allBlogArticles[0].author}</p>
              <p className="text-xs text-foreground-500">{allBlogArticles[0].role}</p>
            </div>
          </div>
          <div className="w-6 h-6 flex items-center justify-center text-primary-400">
            <i className="ri-double-quotes-l text-xl"></i>
          </div>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
            {allBlogArticles[0].title}
          </h3>
        </Link>

        {/* Card 2 - Text */}
        <Link
          to={`/blog/${allBlogArticles[1].slug}`}
          className="bg-white rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer flex flex-col gap-4"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center overflow-hidden">
              <span className="text-secondary-700 font-semibold text-sm">
                {allBlogArticles[1].author.split(" ").map((n) => n[0]).join("")}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-900">{allBlogArticles[1].author}</p>
              <p className="text-xs text-foreground-500">{allBlogArticles[1].role}</p>
            </div>
          </div>
          <div className="w-6 h-6 flex items-center justify-center text-primary-400">
            <i className="ri-double-quotes-l text-xl"></i>
          </div>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
            {allBlogArticles[1].title}
          </h3>
        </Link>

        {/* Card 3 - Image background */}
        <Link
          to={`/blog/${allBlogArticles[2].slug}`}
          className="relative rounded-2xl overflow-hidden group cursor-pointer h-64"
        >
          <img
            src={allBlogArticles[2].cardImage}
            alt={allBlogArticles[2].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <p className="text-white/80 text-xs mb-1">{allBlogArticles[2].author} · {allBlogArticles[2].role}</p>
            <h3 className="text-white font-heading font-semibold text-lg leading-snug">
              {allBlogArticles[2].title}
            </h3>
          </div>
        </Link>

        {/* Card 4 - Large image background */}
        <Link
          to={`/blog/${allBlogArticles[3].slug}`}
          className="md:col-span-2 relative rounded-2xl overflow-hidden group cursor-pointer h-64 md:h-72"
        >
          <img
            src={allBlogArticles[3].cardImage}
            alt={allBlogArticles[3].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <p className="text-white/80 text-xs mb-1">{allBlogArticles[3].author} · {allBlogArticles[3].role}</p>
            <h3 className="text-white font-heading font-semibold text-xl md:text-2xl leading-snug max-w-lg">
              {allBlogArticles[3].title}
            </h3>
          </div>
        </Link>

        {/* Card 5 - Small text card (part of the stacked pair) */}
        <Link
          to={`/blog/${allBlogArticles[4].slug}`}
          className="bg-white rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer flex flex-col gap-3"
        >
          <div className="w-5 h-5 flex items-center justify-center text-primary-400">
            <i className="ri-double-quotes-l text-base"></i>
          </div>
          <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
            {allBlogArticles[4].title}
          </h3>
          <div className="flex items-center gap-2 mt-auto">
            <div className="w-7 h-7 rounded-full bg-accent-100 flex items-center justify-center overflow-hidden">
              <span className="text-accent-700 font-semibold text-xs">
                {allBlogArticles[4].author.split(" ").map((n) => n[0]).join("")}
              </span>
            </div>
            <div>
              <p className="text-xs font-medium text-foreground-800">{allBlogArticles[4].author}</p>
              <p className="text-xs text-foreground-500">{allBlogArticles[4].role}</p>
            </div>
          </div>
        </Link>

        {/* Row: Card 6 + Card 7 side by side */}
        <Link
          to={`/blog/${allBlogArticles[5].slug}`}
          className="relative rounded-2xl overflow-hidden group cursor-pointer h-56"
        >
          <img
            src={allBlogArticles[5].cardImage}
            alt={allBlogArticles[5].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-white/80 text-xs mb-0.5">{allBlogArticles[5].author}</p>
            <h3 className="text-white font-heading font-semibold text-sm leading-snug">
              {allBlogArticles[5].title}
            </h3>
          </div>
        </Link>

        <Link
          to={`/blog/${allBlogArticles[6].slug}`}
          className="relative rounded-2xl overflow-hidden group cursor-pointer h-56"
        >
          <img
            src={allBlogArticles[6].cardImage}
            alt={allBlogArticles[6].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-white/80 text-xs mb-0.5">{allBlogArticles[6].author}</p>
            <h3 className="text-white font-heading font-semibold text-sm leading-snug">
              {allBlogArticles[6].title}
            </h3>
          </div>
        </Link>

        {/* Card 8 - Image background */}
        <Link
          to={`/blog/${allBlogArticles[7].slug}`}
          className="relative rounded-2xl overflow-hidden group cursor-pointer h-56"
        >
          <img
            src={allBlogArticles[7].cardImage}
            alt={allBlogArticles[7].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-white/80 text-xs mb-0.5">{allBlogArticles[7].author}</p>
            <h3 className="text-white font-heading font-semibold text-sm leading-snug">
              {allBlogArticles[7].title}
            </h3>
          </div>
        </Link>

        {/* Card 9 + Card 10 in a stacked pair */}
        <div className="flex flex-col gap-4">
          <Link
            to={`/blog/${allBlogArticles[8].slug}`}
            className="bg-white rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer flex-1 flex flex-col gap-3"
          >
            <div className="w-5 h-5 flex items-center justify-center text-primary-400">
              <i className="ri-double-quotes-l text-base"></i>
            </div>
            <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
              {allBlogArticles[8].title}
            </h3>
            <div className="flex items-center gap-2 mt-auto">
              <div className="w-7 h-7 rounded-full bg-accent-100 flex items-center justify-center overflow-hidden">
                <span className="text-accent-700 font-semibold text-xs">
                  {allBlogArticles[8].author.split(" ").map((n) => n[0]).join("")}
                </span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">{allBlogArticles[8].author}</p>
                <p className="text-xs text-foreground-500">{allBlogArticles[8].role}</p>
              </div>
            </div>
          </Link>

          <Link
            to={`/blog/${allBlogArticles[10].slug}`}
            className="bg-white rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer flex-1 flex flex-col gap-3"
          >
            <div className="w-5 h-5 flex items-center justify-center text-primary-400">
              <i className="ri-double-quotes-l text-base"></i>
            </div>
            <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
              {allBlogArticles[10].title}
            </h3>
            <div className="flex items-center gap-2 mt-auto">
              <div className="w-7 h-7 rounded-full bg-secondary-100 flex items-center justify-center overflow-hidden">
                <span className="text-secondary-700 font-semibold text-xs">
                  {allBlogArticles[10].author.split(" ").map((n) => n[0]).join("")}
                </span>
              </div>
              <div>
                <p className="text-xs font-medium text-foreground-800">{allBlogArticles[10].author}</p>
                <p className="text-xs text-foreground-500">{allBlogArticles[10].role}</p>
              </div>
            </div>
          </Link>
        </div>

        {/* Card 11 - Full width */}
        <Link
          to={`/blog/${allBlogArticles[9].slug}`}
          className="md:col-span-2 relative rounded-2xl overflow-hidden group cursor-pointer h-56 md:h-64"
        >
          <img
            src={allBlogArticles[9].cardImage}
            alt={allBlogArticles[9].title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <p className="text-white/80 text-xs mb-1">{allBlogArticles[9].author} · {allBlogArticles[9].role}</p>
            <h3 className="text-white font-heading font-semibold text-base md:text-lg leading-snug max-w-lg">
              {allBlogArticles[9].title}
            </h3>
          </div>
        </Link>
      </div>
    </section>
  );
}